import { getBaiduMapFrontendConfig } from '../api/Sys'

const BAIDU_MAP_API_VERSION = '2.0'
let loadPromise = null

function loadScript(ak) {
  return new Promise((resolve, reject) => {
    if (window.BMap) {
      resolve(window.BMap)
      return
    }
    const callbackName = `__initBaiduMap_${Date.now()}`
    window[callbackName] = () => {
      delete window[callbackName]
      if (!window.BMap) {
        reject(new Error('百度地图脚本加载失败'))
        return
      }
      resolve(window.BMap)
    }
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = `https://api.map.baidu.com/api?v=${BAIDU_MAP_API_VERSION}&ak=${encodeURIComponent(ak)}&callback=${callbackName}`
    script.onerror = () => {
      delete window[callbackName]
      reject(new Error('百度地图脚本加载失败'))
    }
    document.head.appendChild(script)
  })
}

export function ensureBaiduMap() {
  if (window.BMap) {
    return Promise.resolve(window.BMap)
  }
  if (!loadPromise) {
    loadPromise = getBaiduMapFrontendConfig()
      .then((res) => {
        if (res.code !== 200) {
          throw new Error(res.message || '获取百度地图配置失败')
        }
        const ak = res.data && res.data.baiduAk
        if (!ak) {
          throw new Error('未配置百度地图 AK，请联系管理员')
        }
        return loadScript(ak)
      })
      .catch((err) => {
        loadPromise = null
        throw err
      })
  }
  return loadPromise
}

export function preloadBaiduMap() {
  return ensureBaiduMap().catch(() => {})
}
